import { createStructuredSelector } from 'reselect'

import {
  DEMAND_LIST,
  DEMAND_LIST_SUCCESS,
  DEMAND_LIST_ERROR,
  DEMAND_SEARCH_SET,
  DEMAND_PAGE_SET,
  DEMAND_VIEW_MODAL_SET,
  DEMAND_VIEW_TAB_SET,
  DEMAND_SEARCH_CHANGE,
  DEMAND_HEADER,
  DEMAND_SEARCH_PROJECT_LIST,
  DEMAND_SEARCH_PROJECT_LIST_SUCCESS,
  DEMAND_SEARCH_PROJECT_LIST_ERROR,
  DEMAND_DETAIL,
  DEMAND_DETAIL_SUCCESS,
  DEMAND_DETAIL_ERROR,
} from '../actions';

export const NAME = 'demand';

export const DemandList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: DEMAND_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const DemandListSuccess = (data) => ({
  type: DEMAND_LIST_SUCCESS,
  payload: data
});

export const DemandListError = (error) => ({
  type: DEMAND_LIST_ERROR,
  payload: error
});

export const DemandSearchSet = (data) => ({
  type: DEMAND_SEARCH_SET,
  payload: data
});

export const DemandPageSet = (data) => ({
  type: DEMAND_PAGE_SET,
  payload: data
});

export const DemandViewModalSet = (data) => ({
  type: DEMAND_VIEW_MODAL_SET,
  payload: data
});


export const DemandHeader = (data) => ({
  type: DEMAND_HEADER,
  payload: data
});

export const DemandViewTabSet = (data) => ({
  type: DEMAND_VIEW_TAB_SET,
  payload: data
});


export const DemandSearchChangeSet = (data) => ({
  type: DEMAND_SEARCH_CHANGE,
  payload: data
});

export const DemandSearchProjectList = () => ({
  type: DEMAND_SEARCH_PROJECT_LIST
});

export const DemandSearchProjectListSuccess = (message) => ({
  type: DEMAND_SEARCH_PROJECT_LIST_SUCCESS,
  payload: message
});

export const DemandSearchProjectListError = (error) => ({
  type: DEMAND_SEARCH_PROJECT_LIST_ERROR,
  payload: error
}); 

export const DemandDetail = (data) => ({
  type: DEMAND_DETAIL,
  payload: data
});

export const DemandDetailSuccess = (data) => ({
  type: DEMAND_DETAIL_SUCCESS,
  payload: data
});

export const DemandDetailError = (error) => ({
  type: DEMAND_DETAIL_ERROR,
  payload: error
});

const demand = (state) => state[NAME];

export const DemandSelector = createStructuredSelector({
  demand
})
